import Button from './button.vue'

Button.install = Vue => {
  Vue.component(Button.name, Button)
}

export {Button}



// WEBPACK FOOTER //
// ./src/components/button/index.js